















import Vue, { PropType } from "vue"
import MaterialIcon, {
  IconType,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: { MaterialIcon },
  props: {
    iconName: {
      type: String,
      default: null,
    },
    iconType: {
      type: String as PropType<IconType>,
      default: null,
    },
    text: {
      type: String,
      required: true,
    },
    isDarkTag: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisibleIcon(): boolean {
      return this.iconName !== null && this.iconType !== null
    },
  },
})
